<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入案例编号进行搜索"
        v-model="body.keyword"
        clearable
        class="input-with-select dk_input"/>
      <el-button
        type="primary"
        @click="search()">
        搜索
      </el-button>
      <el-button @click="event().clearKeyword()">重置</el-button>
      <div>
        <el-button
          type="primary"
          plain
          @click="event().toAddOrEditClick()">新建轮播图</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="priority"
        label="排序"/>
      <el-table-column
        label="轮播图"
        width="161">
        <template slot-scope="scope">
          <img
            :src="imgDomain+'/'+scope.row.img_src"
            width="141px" @click="imgPre(imgDomain+'/'+scope.row.img_src)">
        </template>
      </el-table-column>
      <el-table-column
        prop="example_uuid"
        label="案例编号"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="330">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toAddOrEditClick(scope.row.uuid)">
            编 辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            class="mini-el-button"
            plain
            @click="event().onDelClick(scope.row.uuid)">
            删 除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>
    <modal :url='imgPreUrl' :modal='modal' style="width:100%" @chose='chose'></modal>
  </el-main>
</template>

<script>
import { getBannerList, deleteBanner } from '../../api/case'
import { imgDomain } from '../../configs/env'
import commoonFunction from '../../mixins/common'

import modal from '../../components/modal'
export default {
  components:{
    modal
  },
  mixins: [commoonFunction],
  data() {
    return {
      imgDomain,
      body: {
        keyWord: '',
        page_index: 1,
        page_size: 20,
      },
      total: 0,
      tableData: [
        {},
      ],
      imgPreUrl:'',
      modal:false,
    };
  },
  created() {
    this.network().getBannerList()
  },
  methods: {
    imgPre(url){
      this.modal=true
      this.imgPreUrl=url
    },
    chose(e){
      this.modal=e
    },
    search() {
      this.network().getBannerList()
    },
    handleCurrentChange() {
      this.network().getBannerList()
    },
    event() {
      return {
        clearKeyword: () => {
          this.body.keyword = ''
        },
        toAddOrEditClick: (uuid) => {
          this.$router.push({ path: 'banner-add', query: { uuid } })
        },
        onDelClick: (uuid) => {
          this.isDel('确定删除轮播图, 是否继续?', 'deleteBanner', uuid)
        },
      }
    },
    network() {
      return {
        getBannerList: async () => {
          const { status, data } = await getBannerList(this.body)
          if (status !== 200) return
          this.tableData = data.data
          this.total = data.total
        },
        deleteBanner: async (uuid) => {
          const { status } = await deleteBanner({'uuid': uuid})
          if (status !== 200) return
          this.network().getBannerList()
          this.$notify({
            title: '删除成功',
            message: '删除轮播图成功',
            type: 'success',
          });
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/case/case-banner.vue